<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <div class="flex flex-col gap-8">
    <new-ui-multiselect
      [ngModel]="selectedOptions"
      [formlyAttributes]="field"
      [options]="props.options | formlySelectOptions: field | async"
      [optionLabel]="props.optionLabel ?? 'label'"
      [optionValue]="props.optionValue ?? 'value'"
      [optionGroupChildren]="props.optionGroupChildren ?? 'group'"
      [label]="props.label"
      [showClear]="true"
      [required]="props.required"
      [readonly]="props.readonly"
      [showToggleAll]="false"
      (changed)="change($event.value, $event.itemValue)"
      (cleared)="clear()"
    />

    @if (!props.readonly) {
      <div class="row flex-wrap empty:hidden">
        @for (field of formControl.value; track field) {
          <p-chip
            icon="icon-[mi--pencil]"
            [label]="field.experienceField | staticData: props.staticDataType | async"
            [removable]="true"
            (click)="displayOverlay($event, field)"
            (onRemove)="$event.stopPropagation(); remove(field)"
          />
        }
      </div>
    }
  </div>

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>

@if (!props.readonly) {
  <p-dialog [(visible)]="chipSelected" [modal]="true" appendTo="body">
    <ng-template #header>
      <div class="flex flex-1 items-center">
        <span class="p-dialog-title">
          {{ selectedChip?.experienceField | staticData: props.staticDataType | async }}
        </span>

        @if (translationMapping) {
          <ng-container *appTranslate="let t">
            <new-ui-button
              [dt]="props.dt?.components?.button"
              ariaLabel="translate"
              icon="pi pi-language"
              variant="text"
              severity="secondary"
              [pTooltip]="translationText || t('translation.translate')"
              (onClick)="openDialog($event)"
            />
          </ng-container>
        }
      </div>
    </ng-template>

    <div class="w-overlay dialog-form">
      <p-editor
        [style]="{ height: '120px' }"
        [bounds]="elementRef.nativeElement"
        (onInit)="updateEditor($event.editor)"
      >
        <ng-template #header>
          <span class="ql-formats">
            <select class="ql-size"></select>
          </span>
          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
          </span>
          <span class="ql-formats">
            <select class="ql-color"></select>
            <select class="ql-background"></select>
          </span>
          <span class="ql-formats">
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
          </span>
          <span class="ql-formats">
            <button class="ql-link"></button>
          </span>
        </ng-template>
      </p-editor>

      <div class="col">
        <new-ui-button
          [dt]="props.dt?.components?.button"
          [fluid]="true"
          icon="icon-[mi--checkmark-medium]"
          [label]="props.saveLabel"
          (onClick)="updateHtml(); chipSelected = false"
        />

        <new-ui-button
          [dt]="props.dt?.components?.button"
          [fluid]="true"
          icon="icon-[mi--close-medium]"
          [label]="props.cancelLabel"
          severity="secondary"
          (onClick)="chipSelected = false"
        />
      </div>
    </div>
  </p-dialog>
}
